// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"77ff74ec","455":"b96fa187","977":"9f2a1c57"}[chunkId] + ".chunk.js";
};